import { api } from "@contexts";

export interface NotifyPrescriptionsParams {
  requestId: string;
}

export async function notifyPrescriptions({
  requestId,
}: NotifyPrescriptionsParams): Promise<void> {
  await api({
    method: "post",
    url: `/notifications/prescriptions`,
    data: {
      requestId,
    },
  });
}
